module.exports = __webpack_public_path__ + "static/media/half-donught.808e78ad.svg";